
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const UserCircleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g clip-path="url(#a)"><circle cx="12" cy="12" r="8.253" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.312 16.127H8.689a.51.51 0 0 1-.51-.51v-.414a2.14 2.14 0 0 1 2.134-2.133h3.374a2.14 2.14 0 0 1 2.134 2.133v.414a.51.51 0 0 1-.51.51ZM12 11.083a2.063 2.063 0 1 1 0-4.127 2.063 2.063 0 0 1 0 4.127v0Z" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs></svg>
  </SvgIcon>
);
